<mat-nav-list>
<a mat-list-item
		routerLink="/chargers"
		[class.active]="router.url === '/chargers' || router.url.startsWith('/charger')"
	>
		<mat-icon>bolt</mat-icon>
		<span class="nav-title" i18n="@@titleChargers">Chargers</span>
	</a>
	<a mat-list-item routerLink="/history" routerLinkActive="active">
		<mat-icon>history</mat-icon>
		<span class="nav-title" i18n="@@titleHistory">History</span>
	</a>
	@if (authService.isAdmin() || authService.isSupport()) {
		<a mat-list-item routerLink="/admin" routerLinkActive="active">
			<mat-icon>admin_panel_settings</mat-icon>
			<span class="nav-title" i18n="@@titleAdmin">Admin</span>
		</a>
	}
</mat-nav-list>

<span class="app-version"><span i18n="@@Version">version</span> {{ version }} ({{ commit }})</span>
